<div class="row list_view">
  <div class="col-12 col-md-2">
    <a
      [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
      class="cx-product-image-container"
      tabindex="-1"
    >
      <cx-media
        class="cx-product-image"
        [container]="product.images?.PRIMARY"
        [alt]="product.summary"
      ></cx-media>
    </a>
  </div>

  <div class="col-12 col-md-4">
    <div class="list-content">
      <div class="cx-prodcurt-code">
        {{ product.code }}
      </div>

      <a
        matTooltipClass="vs-tooltip"
        [matTooltip]="product.name"
        [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
        class="cx-product-name"
        [innerHtml]="product.name"
      ></a>

      <div
        *ngIf="
          (product.sellabilityFlag || product.quotabilityFlag) &&
          !hideProductPrice &&
          product?.price &&
          !product.obsoleteProductFlag &&
          checkPriceProduct[product.code] === undefined &&
          loggedIn
        "
        class="cx-product-price-container"
        class="list-price"
      >
        <p>{{ 'plp.listPrice' | cxTranslate }}:</p>

        <div class="cx-product-price" aria-label="Product price">
          {{ currency }} {{ product.price.formattedValue }}
        </div>
      </div>

      <div
        *ngIf="
          (product.sellabilityFlag || product.quotabilityFlag) &&
          !hideProductPrice &&
          checkPriceProduct[product.code] !== undefined &&
          checkPriceProduct[product.code].price !== undefined &&
          checkPriceProduct[product.code].price.value > 0 &&
          loggedIn
        "
        class="cx-product-price-container"
        class="list-price"
      >
        <p>{{ 'plp.listPrice' | cxTranslate }}:</p>

        <div class="cx-product-price" aria-label="Product price">
          {{ currency }}
          {{ checkPriceProduct[product.code].price.formattedValue }}
        </div>
      </div>

      <div
        *ngIf="
          (product.sellabilityFlag || product.quotabilityFlag) &&
          !hideProductPrice &&
          !showError &&
          !product?.price &&
          !product.obsoleteProductFlag &&
          checkPriceProduct[product.code] === undefined &&
          loggedIn
        "
        class="cx-product-price-container"
        class="list-price"
      >
        <p>{{ 'plp.listPrice' | cxTranslate }}:</p>

        <div class="cx-product-price" aria-label="Product price">
          {{ 'plp.unavailable' | cxTranslate }}
        </div>
      </div>
      <div *ngIf="showError" class="text-danger">
        {{ 'plp.priceNotAvailable' | cxTranslate }}
      </div>

      <div
        *ngIf="
          (product.sellabilityFlag || product.quotabilityFlag) &&
          !hideProductPrice &&
          !showError &&
          checkPriceProduct[product.code] !== undefined &&
          (checkPriceProduct[product.code].price?.value === 0 ||
            !checkPriceProduct[product.code].price?.value) &&
          loggedIn
        "
        class="cx-product-price-container"
        class="list-price"
      >
        <p>{{ 'plp.listPrice' | cxTranslate }}:</p>

        <div class="cx-product-price-custom" aria-label="Product price">
          {{ 'plp.toBeQuoted' | cxTranslate }}
          <em
            class="material-icons info help pricentavail"
            matTooltipClass="vs-tooltip"
            matTooltip="{{ 'plp.priceNotAvailable' | cxTranslate }}"
            >info</em
          >
        </div>
      </div>
      <div class="text-warning legacy-text" *ngIf="product.newLegacyMaterial">
        <span class="material-icons">warning </span>
        {{
          'plp.legacyMaterial'
            | cxTranslate : { partNo: product?.newLegacyMaterial }
        }}"
      </div>
      <div class="text-warning" *ngIf="product.obsoleteProductFlag">
        <span class="material-icons">warning </span
        >{{ 'plp.obsoletePart' | cxTranslate }}
      </div>

      <div>
        <div>
          <p class="cx-product-summary" [innerHtml]="product.summary">
            {{ product.summary }}
          </p>
        </div>

        <div class="col-12 col-md-3"></div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-6">
    <cx-add-to-cart
      class="listItem"
      [view]="view"
      [product]="product"
      [productCode]="product?.code"
      [showQuantity]="true"
      (emitCheckPriceProductObj)="fetchCheckPriceProductObj($event)"
      (priceNotFound)="priceNotFound($event)"
    ></cx-add-to-cart>

    <a
      class="favorite-section"
      *ngIf="
        (user$ | async) &&
        (product?.sellabilityFlag || product?.quotabilityFlag)
      "
      (click)="onFavoriteClick(product)"
    >
      <em class="material-icons overlay-fav-icon">{{
        favStatus ? 'star' : 'star_border'
      }}</em>
      <span class="overlay-fav-txt">
        {{
          favStatus ? 'Remove from Favorite List' : 'Add to Favorite List'
        }}</span
      >
    </a>
  </div>
</div>
